export default __webpack_public_path__ + "static/media/Thug's Armbands of the Black Arts.57ee4cea.jpg";